import { ProgramSummaryModal } from '../../quest/summary/ProgramSummaryModal';
import { getProgramSummaryForSubmitDownload } from '../../common/services/program-service';
import { submitProgram } from '../../common/handler/SubmitProgram';
import jobsService from '@/app/features/dashboard/jobs-list/jobs-service';
import { modalUtils } from '@/app/core/utils';
import { Modal } from '@ssar-app/uikit';
import { SSARProgram } from '@ssar-app/domain';

export const showProgramSummary = async (
  model: SSARProgram,
  programId: string,
  version: string,
  showAccept: boolean,
  buildPath: (...paths: string[]) => string,
  draftId?: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history?: any,
  setIsProcessing?: (processing: boolean) => void,
): Promise<void> => {
  const modal = Modal.info({
    icon: false,
    showFooterBtns: false,
    contentProps: { maxW: '80%' },
    content: <></>,
  });
  const closeModal = modal.destroy;
  let job = undefined;
  if (!showAccept) {
    job = await jobsService.getJobInfoById(programId);
  }
  modal.update({
    content: (
      <ProgramSummaryModal
        model={model}
        version={version}
        showAccept={showAccept}
        closeModal={closeModal}
        job={job}
        onAccept={() => {
          if (showAccept) {
            submitProgram(
              model,
              model?.orderDetails?.name || '',
              programId,
              draftId || '',
              history,
              closeModal,
              buildPath,
            );
          }
        }}
        onCancel={() => {
          setIsProcessing && setIsProcessing(false);
          closeModal();
        }}
        onDownload={(setDownloadLoading) => {
          getProgramSummaryForSubmitDownload(
            model.orderDetails?.name || 'ProgramSummary',
            model,
            version,
          )
            .catch((err) => {
              modalUtils.showError(
                err,
                'Error while generating Program Summary',
              );
            })
            .finally(() => {
              setDownloadLoading(false);
            });
        }}
      />
    ),
  });
};
